import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";
import { createComponent, enableProdMode } from "@angular/core";
import {
  Ambiente,
  PucxAppConfig,
  Bootstrap,
  LayoutComponent,
} from "@pucomex-ng-infra/pucx-plataforma-client";
import { CaptchaComponent } from "./app/shared/components/captcha/captcha.component";

[
  "/portal/assets/js/jquery.pucx-plataforma.js",
  "/portal/assets/js/angularjs.pucx-plataforma-integration.js",
].forEach((scriptSrc) => {
  fetch(scriptSrc, { method: "HEAD" }).then((response) => {
    if (response.ok) {
      const script = document.createElement("script");
      script.src = scriptSrc;
      document.querySelector("body")!.appendChild(script);
    } else {
      console.error(`Script não encontrado: ${scriptSrc}`);
    }
  });
});
if (environment.production) {
  enableProdMode();
}
function bootstrap() {
  bootstrapApplication(LayoutComponent, appConfig)
  // injeção do classif-captcha
  .then(appRef => {
    const hostElement = document.querySelector('classif-captcha');
    if (hostElement) {
      const captchaRef = createComponent(CaptchaComponent, {
        environmentInjector: appRef.injector,
        hostElement
      });
      appRef.attachView(captchaRef.hostView);
      return appRef // para encadeamento
    }
  })
  .catch((err) =>
    console.error(err)
  );
}
let ambiente = new Ambiente(
  environment.appContext,
  environment.appVersion,
  environment.buildVersion
);
let pucxConfig = new PucxAppConfig(ambiente, bootstrap);
const b: Bootstrap = new Bootstrap(pucxConfig);
b.initPortal();
